import { HttpClient, HttpRequest } from '@angular/common/http';
import { Injectable, EventEmitter } from '@angular/core';
import { CoreService } from '../core.service';
import { SettingsService } from '../settings/settings.service';
import { User } from '../app.models';

@Injectable({ providedIn: 'root' })
export class ProfileService {

	constructor(
		public http: HttpClient,
		public core: CoreService,
		public settings: SettingsService,
	){
		this.core.profile = this;

		if( !this.is_premium && !this.settings.is_explicit('show_leaderboard') ){
			this.settings.set('show_leaderboard', true, false);
		}

		this.core.stateshot_synced.subscribe( () => this.stateshot_parse() );
		this.stateshot_parse();
	}
	stateshot_parse(){
		this.tag_chances = this.core.stateshot['configs']['tag_chances'];
		this.tag_chances_wk = this.core.stateshot['configs']['tag_chances_wk'];
		this.tag_repeats = this.core.stateshot['configs']['tag_repeats'];
	}

	get userinfo(){ return window['userinfo']; }

	//User Auth and Prediction/Bet Data
	user_synced: EventEmitter<null> = new EventEmitter();
	user: User = User.get_anon();

	chat_user: any = null; //Duplicate of core
	get url_path(): string { return window.location.pathname; } //Duplicate of core


	auth_pending = true; //We don't know if the user is logged in or not.
	authenticate_timeout = null;
	get is_authenticated(){ return !!this.user.token; }
	async authenticate( token = null ){

		let response;
		if( token ){
			token['bungee_id'] = this.core.stateshot['meta']['bungee_id'];
			response = await this.core.json_request( "POST", "/api/v1/accounting/login_with_bungee", token );
		} else {
			response = await this.core.json_request( "POST", "/api/v1/accounting/refresh_me", {"token": this.user.token } );
		}
		if( !response.ok ) return;
		if( !response.json ){
			this.user = null;
			this.setupTagRepeats();
			this.core.events.emit("profile.auth-changed");
			this.user_synced.emit();
			return;
		}

		let already_authenticated = !!this.user.token;

		if( already_authenticated )
			this.user.update( response.json, (new Date()).getTime() );
		else
			this.user = new User( response.json );



		if( this.user.tag_exempt )
			this.isTagEnabled = false;
		else
			this.setupTagRepeats() //Will only run once!

		if( this.authenticate_timeout !== null )
			clearTimeout( this.authenticate_timeout )
		this.authenticate_timeout = setTimeout( () => { this.authenticate() }, 60000 * ( 10 + Math.random() ) ); //10~11 minutes

		if( !this.is_premium )
			this.core.events.emit( this.core.device_is_webkit ? "vpn_webkit_eligible" : "vpn_eligible" );

		if( already_authenticated )
			this.core.events.emit("profile.user-update");
		else
			this.core.events.emit("profile.auth-changed");

		this.user_synced.emit();
	}
	logout(){
		this.user = User.get_anon();
		this.core.events.emit("profile.auth-changed");
	}


	//Premium Access
	premium_info = this.userinfo['premium'];
	premium_code = this.premium_info ? this.premium_info['code'] : false;
	premium_type = this.userinfo['hfu'] ? 'HFU': (this.premium_info ? 'CODE' : false);
	premium_sig  = null;

	get is_premium(){ return !!this.premium_type };

	async maintain_premium_sig( manual = false ){

		if( manual )
			this.premium_sig = null;

		if( !manual && localStorage["premium_sigexp"] && (60 < +localStorage["premium_sigexp"] - Math.floor((new Date()).getTime() / 1000)) ){
			this.premium_sig = localStorage["premium_sig"];
			setTimeout( ()=>{ this.maintain_premium_sig() }, 50000 );
			return;
		}

		let response = await this.core.json_request("POST", "/api/v1/premium/generate_token", {
			"code" : this.premium_info['code'] || "NO-CODE",
			"ent_name": this.premium_info['credit']['entitlement']['name'],
			"device_uuid" : localStorage['device_uuid'],
		})

		if( !manual )
			setTimeout( ()=>{ this.maintain_premium_sig() }, 50000 );

		if( !response.ok ){
			this.premium_sig = false;
			return;
		}

		this.premium_sig = response.json['token'];
		localStorage["premium_sigexp"] = Math.floor((new Date()).getTime() / 1000) + 60*60*2;
		localStorage["premium_sig"] = response.json['token'];
		//this.onNewPremiumSig.emit(null);

	}
	premium_softcheck(){
		return ;
		this.http.get( "https://account24network.com/api/profile/device_id_soft_check/" + localStorage['device_uuid'] ).subscribe(r=>{
			if( r === false ) this.premium_logout( 'max_device_error' );
		})
	}
	premium_logout( logout_reason = 'manual' ){
		localStorage.removeItem('premium_sig');
		localStorage.removeItem('premium_sigexp');

		var f    = document.createElement('form');
		f.action = `/`;
		f.method = 'POST';
		f.target = '_self';

		var i   = document.createElement('input');
		i.type  = 'hidden';
		i.name  = 'logout';
		i.value = logout_reason;
		f.appendChild(i);

		document.body.appendChild(f);
		f.submit();
	}





	//Advertisement
	isTagRunning: boolean = false;
	isTagEnabled: boolean = true;
	isTagRepeated: boolean = false;
	tag_chances: any[] = null; //[ [0.4: '/sport-assets/brtg.js'], ... ]
	tag_chances_wk: any[] = null;
	get tagChances(){ return this.core.device_is_webkit ? this.tag_chances_wk : this.tag_chances }

	tag_repeats: number[] = null; //[0, 1200, 60, ...]
	tagsRan: Set<string> = new Set();

	activateTag(){
		if( this.is_premium ) return;
		if( this.core.is_premium ) return;
		if( !this.isTagEnabled ) return;
		if( !this.tagChances ) return;

		if( this.url_path.startsWith("/runtag/") )
			try { //Try to run a test tag!
				this.isTagEnabled = false;

				let tag = "/sport-assets/" + this.url_path.split("/runtag/")[1] + ".js"; //this.tagChances.map( t => t[1] ).filter( t => t.endsWith( this.url_path.split("/runtag/")[1] + ".js" ) )[0];
				this.tagsRan.add( tag );

				setTimeout(() => {
					var script = document.createElement( "script" )
					script.type   = "text/javascript";
					script.async  = true
					script.src    = tag;
					document.body.appendChild( script );
					this.isTagRunning = true;
				}, 1000);

				console.log( "RunTag Result:" + tag )
				return;
			} catch(e){ console.log("RunTag test failed!"); }


		let sum = 0;
		let rnd = Math.random();
		console.log( "RND:", rnd );


		for( var tagchance of this.tagChances ){
			sum += tagchance[0];

			if( rnd < sum ){
				if( this.tagsRan.has( tagchance[1] ) ){
					rnd += tagchance[0]; //Skip this chance, it already ran!
					continue;
				}

				for( let i = 1; i < tagchance.length - 1; i += 2 ){
					let tag = tagchance[i], delay = +(tagchance[i+1] || '0');

					console.log("TAGOF", tag)

					if( this.tagsRan.has( tag ) )
						continue;

					if( this.is_authenticated && this.core.device_is_webkit && tag.includes("brtg") ){
						this.tagsRan.add( tag );
						continue;
					}

					setTimeout(() => {
						var script = document.createElement( "script" )
						script.type   = "text/javascript";
						script.async  = true
						script.src    = tag;
						document.body.appendChild( script );
						this.isTagRunning = true;

					}, delay * 1000);
					this.tagsRan.add( tag );

				}

				break;
			}

		}
	}
	setupTagRepeats( force = false ){
		if( this.isTagRepeated && !force ) return;
		this.isTagRepeated = true;

		if( this.tag_repeats === null ){
			setTimeout(()=>{ this.setupTagRepeats( true ) }, 1000)
			return;
		}

		if( this.tag_repeats.length == 0 ) return; //There is no repeat!

		for( let delay of this.tag_repeats )
			setTimeout(() => {
				this.activateTag()
			}, 1000 * delay );
	}

}
